.root {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid
    var(--chartv2-axis-line, var(--border-soft, rgba(255, 255, 255, 8%)));
  background: var(
    --chartv2-surface-raised,
    var(--background-soft, rgba(0, 0, 0, 35%))
  );
  box-shadow: var(--elevation-moderate, 0 2px 8px rgba(0, 0, 0, 30%));
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 3px;
  color: var(--chartv2-axis-label, var(--text-soft, rgba(255, 255, 255, 60%)));
  cursor: pointer;
  transition: color 120ms ease, background-color 120ms ease;
}

.button > svg {
  width: 12px;
  height: 12px;
}

.button:hover {
  background: var(--chartv2-chip-hover, rgba(255, 255, 255, 8%));
  color: var(--chartv2-foreground, var(--text-default, #eee));
}

.button.active {
  background: var(
    --chartv2-chip-active,
    var(--surface-raised, rgba(255, 255, 255, 12%))
  );
  color: var(--chartv2-foreground, var(--text-default, #eee));
}
